/* =============================================================
   TRESTLETHORN — SKU Title Cleaner
   File: assets/tt-sku-cleaner.js

   CWR Distribution appends SKU codes like [35-742-BL] or
   [2000020942] to product titles. This script strips them
   from the visible storefront without touching the actual
   product data in Shopify admin.

   Add to layout/theme.liquid before </body>:
     <script src="{{ 'tt-sku-cleaner.js' | asset_url }}" defer></script>

   NOTE: The real fix is to bulk-edit product titles in Shopify
   admin or ask CWR if they can exclude the SKU from the title
   in their feed. But this JS handles it instantly on the frontend
   while you sort that out on the backend.
   ============================================================= */

(function () {
  'use strict';

  // Matches patterns like [35-742-BL], [SC-10], [2000020942], [RY70083]
  const SKU_PATTERN = /\s*\[[^\]]{2,20}\]\s*$/;

  function cleanTitles() {
    // Patch the browser/SERP title — Google renders JS and re-indexes
    document.title = document.title.replace(SKU_PATTERN, '').trim();

    // All elements that could show a product title
    const selectors = [
      '.card__heading a',
      '.card__heading',
      '.product__title',
      '.product__title h1',
      '.product__title h2',
      '.product__title .h1',
      'a.product__title h2',
      '.cart-item__name',
      '.cart-item__name a',
      '.order-summary__name',
      'h1.title',
      '.modal__header .product__title',
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        const original = el.textContent;
        const cleaned  = original.replace(SKU_PATTERN, '').trim();
        if (cleaned !== original) {
          // Only update the text node, preserve any child elements (like badges)
          // Find the direct text node and update it
          for (const node of el.childNodes) {
            if (node.nodeType === Node.TEXT_NODE && SKU_PATTERN.test(node.textContent)) {
              node.textContent = node.textContent.replace(SKU_PATTERN, '').trim();
            }
          }
          // Fallback: if no text node found but the whole el content matched
          if (el.childNodes.length === 1 && el.childNodes[0].nodeType === Node.TEXT_NODE) {
            el.textContent = cleaned;
          }
        }
      });
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanTitles);
  } else {
    cleanTitles();
  }

  // Re-run after any Shopify section updates (theme editor, dynamic sections)
  document.addEventListener('shopify:section:load', cleanTitles);

  // Re-run when product-recommendations AJAX content is injected
  const recEl = document.querySelector('product-recommendations');
  if (recEl) {
    new MutationObserver(cleanTitles).observe(recEl, { childList: true, subtree: true });
  }

})();
